import React, { Component } from 'react';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import ConfirmationMessage_en from './locales/ConfirmationMessage_en.json';
import ConfirmationMessage_fr from './locales/ConfirmationMessage_fr.json';

class ConfirmationMessage extends Component {
  constructor(props) {
    super(props);

    i18next.addResourceBundle('en', 'TaxReceipt_ConfirmationMessage', ConfirmationMessage_en);
    i18next.addResourceBundle('fr', 'TaxReceipt_ConfirmationMessage', ConfirmationMessage_fr);
  }

  render() {
    const { t } = this.props;

    return (
      <span className="TaxReceipt__ConfirmationMessage">
        {t('message')}
      </span>
    );
  }
}

export default translate('TaxReceipt_ConfirmationMessage')(ConfirmationMessage);
